import React from 'react';
import OpportunityDetailView from 'screens/User/Opportunities/Detail/components/View';

function OpportunityDetail() {
  return <OpportunityDetailView />;
}

export default OpportunityDetail;
